// extracted by mini-css-extract-plugin
export default {"slider-container":"carousel_slider-container__UZTxn","slider-container-arrows":"carousel_slider-container-arrows__aqMQb"};